exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview.in-selection .thumbnail[data-v-8dcbcaaa]{height:132px}.asset-preview.in-selection .thumbnail img[data-v-8dcbcaaa]{max-height:130px}.asset-preview:hover .card-body .asset-info.stay[data-v-8dcbcaaa]{opacity:1}.preview-loading[data-v-8dcbcaaa]{position:absolute;left:0;top:0;right:0;bottom:0;margin:auto;z-index:2;height:20px}", ""]);

// exports
